<template>
	<Popup
		v-model="selfDisplay"
		title="修改"
		confirmBtnText="修改"
		@confirmClick="handleUpdateClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>订单号</span>
				<el-input :value="number" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>流水号</span>
				<div class="b_block" style="width: 200px;">
					<el-input :value="serial" disabled></el-input>
				</div>
				<div class="b_block" style="width: 70px;margin-left: 20px;">
					<el-button class="clipboard" type="primary" :data-clipboard-text="obj.serial">复制</el-button>
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>价格</span>
				<el-input :value="price" disabled>
					<template slot="prepend">￥</template>
				</el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>支付总额</span>
				<el-input :value="amount" disabled>
					<template slot="prepend">￥</template>
				</el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>数量</span>
				<el-input :value="num" disabled>
					<template slot="prepend">个</template>
				</el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>收货地址</span>
				<el-input :value="addr" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>店铺名称</span>
				<el-input :value="shopName" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>购买账户</span>
				<el-input :value="uCode" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>下单时间</span>
				<el-date-picker
					:value="date"
					:editable="false"
					disabled
					type="date"
					value-format="yyyy-MM-dd"
					@change="handleDateChange"
				>
				</el-date-picker>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>发货状态</span>
				<div class="b_checkbox_group">
					<el-radio-group v-model="sendStatus">
						<el-radio v-for="v in appSendStatus" :key="v.id" :label="v.id">{{ v.name }}</el-radio>
					</el-radio-group>
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>订单状态</span>
				<div class="b_checkbox_group">
					<el-radio-group v-model="orderStatus">
						<el-radio v-for="v in appOrderStatus" :key="v.id" :label="v.id">{{ v.name }}</el-radio>
					</el-radio-group>
				</div>
			</div>
			
			<div v-if="orderStatus == 5" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">退款原因</span>
				<el-input v-model="refundReason" placeholder="退款原因"></el-input>
			</div>
			
			<div v-if="orderStatus == 5" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">退款备注</span>
				<el-input v-model="refundRemark" placeholder="退款备注"></el-input>
			</div>
		</div>
	</Popup>
</template>

<script>
	import { mapState } from 'vuex';
	import Api from '../../../../../../../api/index.js';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			obj: {
				type: Object,
				default() { return {}; }
			}
		},
		mounted () {
			this.clipboardInstance = null;
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				number: '',
				serial: '',
				price: '',
				amount: '',
				num: '',
				addr: '',
				shopName: '',
				uCode: '',
				date: '',
				sendStatus: '',
				orderStatus: '',
				refundReason: '',
				refundRemark: ''
			}
		},
		computed: {
			...mapState([
				'appSendStatus',
				'appOrderStatus'
			])
		},
		methods: {
			// 点击复制
			copySerial() {
				
			},
			// 点击修改
			handleUpdateClick() {
				const that = this;
				that.loading = true;
				let requestData = {
					orderId: that.obj.id,
					orderPayStatus: that.orderStatus,
					typeChannel: 1,
					sendFlag: that.sendStatus,
					returnReason: that.refundReason,
					returnRemark: that.refundRemark,
					returnMoney: that.amount
				};
				Api.updateOrderForAppAndMall(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 选择训练时间
			handleDateChange() {
				if (this.date) {
					var destTime = new Date(this.date).getTime(),
						nowTime = new Date().getTime();
					if (destTime > nowTime) {
						this.$message.warning('下单时间不能超过当天');
						this.add_date = '';
					} else {
						this.getWithTrainingInfoByDate('add');
					}
				}
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				const that = this;
				that.$emit("changeDisplay", newVal);
				if (newVal) {
					that.loading = false;
					that.number = that.obj.number;
					that.serial = that.obj.serial;
					that.price = that.obj.price;
					that.amount = that.obj.amount;
					that.num = that.obj.num;
					that.addr = that.obj.addr;
					that.shopName = that.obj.shopName;
					that.uCode = that.obj.uCode;
					that.date = that.obj.time;
					that.sendStatus = that.obj.sendValue;
					that.orderStatus = that.obj.orderStatusValue;
					that.refundReason = '';
					that.refundRemark = '';
					that.clipboardInstance = new that.Clipboard('.clipboard');
					that.clipboardInstance.on('success', () => {
						that.$message.success('复制成功');
					});
				} else {
					that.clipboardInstance && that.clipboardInstance.destroy();
				}
			}
		}
	}
</script>

<style>
</style>
